// Route protection configuration
// When migrating to React, replace with React Router guards

export const publicPages: Array<string> = [
  "/embed/[embed-id]",
  "/",
  "",
  "/affiliation",
  "/pricing",
  "/privacy-policy",
  "/terms-and-conditions",
  "/landing-page"
]

export const embedPages: Array<string> = ["/embed"]

export function isPublicPage(pathname: string): boolean {
  return publicPages.includes(pathname)
}

export function isEmbedPage(pathname: string): boolean {
  return pathname.startsWith("/embed/")
}
